import API from "../../../app/api";

export const getBulkupload = async (formData) => {
  const response = await API.post(
    "/bulk-orders/upload",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
};
